import { CrudManagerLayoutBase } from './layout-base';
import { NgClass, AsyncPipe } from '@angular/common';
import { CrudListComponent } from '../../crud-list/crud-list.component';
import { UiMessageComponent } from '@common/ui/frontend-shared/message';
import { CustomRouterOutlet } from '@core/frontend-shared/router/router-outlet/custom-router-outlet';
import * as i0 from "@angular/core";
const _c0 = ["outlet"];
const _c1 = (a0, a1) => ({
  "medium": a0,
  "large": a1
});
function CrudManagerLayoutListComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ui-message");
    i0.ɵɵelement(1, "div", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.infoMessage, i0.ɵɵsanitizeHtml);
  }
}
function CrudManagerLayoutListComponent_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.placeholder);
  }
}
export let CrudManagerLayoutListComponent = /*#__PURE__*/(() => {
  class CrudManagerLayoutListComponent extends CrudManagerLayoutBase {
    constructor() {
      super(...arguments);
      this.placeholder = "Bitte links ein Item auswählen";
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCrudManagerLayoutListComponent_BaseFactory;
        return function CrudManagerLayoutListComponent_Factory(__ngFactoryType__) {
          return (ɵCrudManagerLayoutListComponent_BaseFactory || (ɵCrudManagerLayoutListComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CrudManagerLayoutListComponent)))(__ngFactoryType__ || CrudManagerLayoutListComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudManagerLayoutListComponent,
        selectors: [["crud-manager-layout-list"]],
        viewQuery: function CrudManagerLayoutListComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.outlet = _t.first);
          }
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 9,
        consts: [["outlet", "outlet"], [1, "main"], [1, "list", 3, "ngClass"], [3, "itemLayout"], [1, "editor"], [1, "placeholder"], [1, "crud-manager-router-outlet"], [3, "innerHTML"]],
        template: function CrudManagerLayoutListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CrudManagerLayoutListComponent_Conditional_0_Template, 2, 1, "ui-message");
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "crud-item-list", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵconditionalCreate(5, CrudManagerLayoutListComponent_Conditional_5_Template, 3, 1, "div", 5);
            i0.ɵɵpipe(6, "async");
            i0.ɵɵelement(7, "custom-router-outlet", 6, 0);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.infoMessage ? 0 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(6, _c1, ctx.config.listWidth === "medium", ctx.config.listWidth === "large"));
            i0.ɵɵadvance();
            i0.ɵɵproperty("itemLayout", ctx.config.itemLayout || "default");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!i0.ɵɵpipeBind1(6, 4, ctx.childRouteActive$) ? 5 : -1);
          }
        },
        dependencies: [UiMessageComponent, NgClass, CrudListComponent, CustomRouterOutlet, AsyncPipe],
        styles: ["[_nghost-%COMP%]{padding:0;display:flex;flex-direction:column;width:100%;height:100%}[_nghost-%COMP%]{padding:3px;background:var(--backgroundSoftColor);display:flex!important}.main[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex:1}.list[_ngcontent-%COMP%]{position:relative;min-width:150px;max-width:220px;flex:1;border-right:3px solid var(--backgroundSoftColor)}.list.medium[_ngcontent-%COMP%]{min-width:220px;max-width:280px}.list.large[_ngcontent-%COMP%]{min-width:280px;max-width:350px}[_nghost-%COMP%]   .list[_ngcontent-%COMP%]     crud-item-list{position:absolute;inset:0}[_nghost-%COMP%]   .list[_ngcontent-%COMP%]     crud-item-list .p-orderlist-list-container{position:absolute;inset:0}.editor[_ngcontent-%COMP%]{position:relative;flex:4;background:var(--backgroundSoftColor);display:flex;width:100%;height:100%;flex-direction:column}.editor[_ngcontent-%COMP%]   .crud-manager-router-outlet[_ngcontent-%COMP%] +   *{position:absolute;display:block;inset:0;z-index:1000;background:var(--contentColor)}.editor[_ngcontent-%COMP%] > .placeholder[_ngcontent-%COMP%]{display:flex;flex:1;align-items:center;justify-content:center;opacity:.4;font-size:1.15rem}[_nghost-%COMP%]     .box>ui-panel>.p-widget>.p-panel-content-wrapper>.p-panel-content{border:0;padding:0}\n\n/*# sourceMappingURL=layout-list.component.ts-angular-inline--33.css.map*/"]
      });
    }
  }
  return CrudManagerLayoutListComponent;
})();